import {MI} from "../init";
import AbstractSymbol from "./AbstractSymbol";

/**
 * @constructor
 * @extends {AbstractSymbol}
 * @param {MadnesObject} sprite
 * @param {number} symbolNum
 * @param {number} reelX
 * @param {number} reelY
 * @returns {SymbolAlchemist}
 */
export default function SymbolAlchemist(sprite, symbolNum, reelX, reelY) {
    AbstractSymbol.call(this, sprite, symbolNum, reelX, reelY);

    /** @type {MadnesObject} */
    this._standShineObject;
    /** @type {MadnesObject} */
    this._shineSpreadObject;
    /** @type {MadnesObject} */
    this._spreadObject;
    /** @type {MadnesObject} */
    this._spreadObjectBg;
    /** @type {MadnesObject} */
    this._handLeftObject;
    /** @type {MadnesObject} */
    this._handRightObject;

    /** @type {MadnesObject} */
    this._conjureObject;

    //this._wildAppearObject;
    //this._wildAppearResolver;

    /** @type {string} */
    this._spreadPosition;

    this._spreaded = false
};

SymbolAlchemist.prototype = Object.create(AbstractSymbol.prototype);
SymbolAlchemist.prototype.constructor = SymbolAlchemist;

SymbolAlchemist.shineColor = 0x03a3ff;

/**
 * @returns {number}
 */
SymbolAlchemist.prototype.getShineColor = function() {
    return SymbolAlchemist.shineColor;
};

/**
 * @param {string} pos
 * @returns {Object}
 */
SymbolAlchemist.prototype.getPositionData = function(pos) {

    var data = {
        'shiftY': 0,
        'spreadShiftY': 0,
        'spriteAnchor': 0.5,
        'handsShiftY': -65
    };

    if(pos === "top") {
        data['shiftY'] = -206/2 - 30;
        data['spreadShiftY'] = 10;
        data['spriteAnchor'] = 0;
        data['handsShiftY'] = 270;

    } else if(pos === "bottom") {
        data['shiftY'] = 206/2 + 30;
        data['spreadShiftY'] = -10;
        data['spriteAnchor'] = 1;
        data['handsShiftY'] = -405;
    }

    return data;
};

SymbolAlchemist.prototype.clear = function() {
    //this.parentSprite.setTexture("symbols_atlas");
    this._clearParentSprite();

    //this._standShineObject = null;

    //this._wildAppearResolver = null;

    this.removeChilds();
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolAlchemist.prototype.createSymbol = function() {
    this.clear();
    this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName);
    return this;
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolAlchemist.prototype.createSimpleSymbol = function() {
    return this.createSymbol();
};

/**
 * @param {string} position
 * @param {boolean} visible
 * @returns {undefined}
 */
SymbolAlchemist.prototype.createSpreadBlurSymbol = function(position, visible) {
    this.clear();

    this.spreaded = true;
    this._spreadPosition = position;

    var posData = this.getPositionData('center');

    this.parentSprite.setAnchor(.5, .5);

    this.parentSprite.setScale(1, 1);
    this.parentSprite.setVisible(visible);

    this._spreadObject = this.createImage(0, 0, "symbols_blur_atlas").setFrameName("symbol_Alchemist_cast_blur");
    this._spreadObject.setAnchor(0.5, 0.5);

    this._handLeftObject = this.createImage(-112, 0, "symbols_blur_atlas").setFrameName("symbol_Alchemist_hand_L_blur");
    this._handLeftObject.setAnchor(0.5, 0.5);

    this._handRightObject = this.createImage(112, posData['handsShiftY'], "symbols_blur_atlas").setFrameName("symbol_Alchemist_hand_P_blur");
    this._handRightObject.setAnchor(0.5, 0.5);
};

SymbolAlchemist.prototype.centerSpread = function() {

    this.parentSprite.setAnchor(.5, .5);
    this._shineSpreadObject && this._shineSpreadObject.setAnchor(.5, 0.5);
    this._shineSpreadObject.setPosY(-206);

    this._spreadObject.setAnchor(.5, .5);
    this._spreadObject.setPosY(-206);
};

/**
 * @param {string} position
 * @param {boolean} visible
 * @returns {SymbolAlchemist}
 */
SymbolAlchemist.prototype.createSpreadSymbol = function(position, visible) {
    this.clear();

    this.spreaded = true;
    this._spreadPosition = position;

    var posData = this.getPositionData(this._spreadPosition);

    this.parentSprite.setAnchor(.5, posData['spriteAnchor']);
    this.parentSprite.setScale(1, 1);
    this.parentSprite.setVisible(visible);

    this._shineSpreadObject = this.createImage(0, posData['shiftY'], "symbol_Alchemist_shine_static_atlas");
    this._shineSpreadObject.setAnchor(0.5, posData['spriteAnchor']).setScale(2.5, 2.5).setBlend("ADD");

    this._shineSpreadObject.createAnims();
    this._shineSpreadObject.anims.add("shine", MI.generateFrameNames("symbol_Alchemist_shine_static_", 0, 23, "", 5));

    this._spreadObject = this.createImage(0, posData['shiftY'] + posData['spreadShiftY'], "symbol_Alchemist_cast_atlas").setFrameName("symbol_Alchemist_cast");
    this._spreadObject.setAnchor(0.5, posData['spriteAnchor']);

    this._spreadObjectBg = this.createImage(0, posData['shiftY'] + posData['spreadShiftY'], "symbol_Alchemist_cast_atlas").setFrameName("symbol_Alchemist_cast_bg");
    this._spreadObjectBg.setAnchor(0.5, posData['spriteAnchor']);
    this._spreadObjectBg.setVisible(false);
    //this._spreadObjectBg.setTint(SymbolFlask.shineColorQ);

    this._handLeftObject = this.createImage(-112, posData['shiftY'] + posData['handsShiftY'], "symbol_Alchemist_cast_atlas").setFrameName("symbol_Alchemist_hand_L");
    this._handLeftObject.setAnchor(0.5, 0.5);

    this._handRightObject = this.createImage(112, posData['shiftY'] + posData['handsShiftY'], "symbol_Alchemist_cast_atlas").setFrameName("symbol_Alchemist_hand_P");
    this._handRightObject.setAnchor(0.5, 0.5);

    return this;
};

SymbolAlchemist.prototype.createStandAnim = function() {
    if (!this._standShineObject) {
        this._standShineObject = this.createImage(0, 0, "symbol_Alchemist_shine_atlas")
            .setBlend("ADD").setScale(2.5, 2.5); //.setVisible(false);

        this._standShineObject.createAnims();
        this._standShineObject.anims.add("shine", MI.generateFrameNames("symbol_Alchemist_shine_", 0, 23, "", 5));
    }
};

SymbolAlchemist.prototype.playStandAnim = function() {
    if(this._standShineObject) {
        this._standShineObject.setVisible(!this._spreaded);
        if (!this._spreaded)
            this._standShineObject.anims.loop("shine", 26);
    }
};

SymbolAlchemist.prototype.stopStandAnim = function() {
    this._standShineObject && this._standShineObject.anims && this._standShineObject.anims.stop();
};

SymbolAlchemist.prototype.fadeOutStandAnim = function() {};
SymbolAlchemist.prototype.fadeInStandAnim = function() {};

/**
 * @returns {SymbolAlchemist}
 */
SymbolAlchemist.prototype.createWinSymbol = function() {
    this.createSymbol();

    /*this._winShineObject = this.createImage(0, 0, "symbol_Alchemist_shine_atlas", this.spriteName + "_winshine")
        .setBlend("ADD").setScale(3, 3).setVisible(false).setAlpha(1);
    this._winShineAnim = this._winShineObject.createAnims();
    this._winShineAnim.add("shine", MI.generateFrameNames("symbol_Alchemist_", 1, 30, "", 5));

    this._winShineAnim.addOnComplete(function() {

        MI.addTween().to(this._winShineObject, { 'alpha': 0 }, {
            'duration': 300,
            'callback': function() {
                this._winShineObject.destroy();
                this._winAnimResolver();
            }.bind(this)
        });

    }.bind(this));*/

    return this;
};

/**
 * @public
 * @returns {Promise}
 */
SymbolAlchemist.prototype.playSpreadAnim = function(d) {

    var duration = typeof d === 'undefined' ? 200 : d;

    return new Promise(function(res) {

        this.parentSprite.setVisible(true);
        this.parentSprite.setAlpha(0);
        this.parentSprite.setScale(1, 0.7);

        this._shineSpreadObject.anims.loop("shine", 26);

        MI.addTween().to(this.parentSprite, { 'alpha': 1 }, {
            'duration': duration * 0.7,
            'callback': function() {}
        });

        MI.addTween().to(this.parentSprite, { 'y': 1 }, {
            'duration': duration,
            'scale': true,
            'callback': res
        });
        this._spreaded = true
    }.bind(this));
};

SymbolAlchemist.prototype.stopSpreadAnim = function() {
    this._shineSpreadObject.anims && this._shineSpreadObject.anims.stop();
};

SymbolAlchemist.prototype.removeSpreadAnim = function() {

    this.stopSpreadAnim();

    this._spreadWrapper.destroy();
    this._spreadWrapper = null;
    this._shineSpreadObject = null;
    this._spreadObject = null;
    this._spreadObjectBg = null;
    this._handLeftObject = null;
    this._handRightObject = null;
};

SymbolAlchemist.prototype.createConjureAnim = function(color) {

    var y = -55;

    if(this._spreadPosition === "top") {
        y = 150;
    }

    if(this._spreadPosition === "bottom") {
        y = -260;
    }

    this._conjureObject = this.createImage(0, y, "cast_shine_atlas")
        .setBlend("ADD").setScale(3, 3).setVisible(false);

    if(color) {
        this._conjureObject.setTint(color);
    }

    this._conjureObject.createAnims();
    this._conjureObject.anims.add("conjureup", MI.generateFrameNames("cast_shine_", 1, 24, "", 5));
    this._conjureObject.anims.addOnComplete(function() {
        this._conjureObject.anims.destroy();
        this._conjureObject.destroy();
        this._conjureObject = null;
    }.bind(this));
};

SymbolAlchemist.prototype.playConjureAnim = function() {

    if(this._conjureObject) {
        this._conjureObject.setVisible(true);
        this._conjureObject.anims.play("conjureup", 50);
    }

    var lx = this._handLeftObject.getPosX();
    var rx = this._handRightObject.getPosX();

    MI.addTween().to(this._handLeftObject, { 'x': lx + 25 }, {
        'duration': 125,
        'yoyo': true
    });

    MI.addTween().to(this._handRightObject, { 'x': rx - 25 }, {
        'duration': 125,
        'yoyo': true
    });
};

/**
 * @param {number} color
 */
SymbolAlchemist.prototype.playBgAnim = function(color) {

    var _self = this;

    this._spreadObjectBg.setVisible(true);
    this._spreadObjectBg.setAlpha(0);
    this._spreadObjectBg.setTint(color);

    MI.addTween().to(this._spreadObjectBg, { 'alpha': 1 }, {
        'duration': 160,
        //'yoyoDelay': 500,
        //'yoyo': true,
        'callback': function() {

            MI.addTween().to(_self._spreadObjectBg, { 'alpha': 0 }, {
                'delay': 500,
                'duration': 400,
                'callback': function() {
                    _self._spreadObjectBg.setVisible(false);
                }
            });
        }
    });
};

SymbolAlchemist.prototype.playWinAnim = function() {};